<ng-container [ngSwitch]="type">
    <div [ngClass]="{ 'flipped': flipped }">
        <ng-container *ngSwitchCase="'wave-left'">
            <div class="hand hand--wave-left hand--{{ device }}" ins-animate-in-view>
                <div class="hand__waving hand__waving--animation"></div>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="'point-left'">
            <div class="hand hand--{{ device }}" ins-animate-in-view>
                <div class="hand__pointing hand__pointing--animation"></div>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="'point-top'">
            <div class="hand hand--point-top hand--{{ device }}" ins-animate-in-view>
                <div class="hand__pointing hand__pointing--animation"></div>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="'point-right'">
            <div class="hand hand--point-right hand--{{ device }}" ins-animate-in-view>
                <div class="hand__pointing hand__pointing--animation"></div>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="'point-bottom'">
            <div class="hand hand--point-bottom hand--{{ device }}" ins-animate-in-view>
                <div class="hand__pointing hand__pointing--animation"></div>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="'sign'">
            <div class="hand hand--{{ device }} hand--position" ins-animate-in-view>
                <div class="hand__signing hand__signing--{{ size }} hand__signing--animation hand__signing--animation-{{ size }}"></div>
                <div class="hand__signing-text hand__signing-text--{{ size }} hand__signing-text--animation">
                    <span class="hand__signing-title hand__signing-title--{{ size }}">
                        <span class="small">Hoera! InShared<br>scoort een</span>
                        <strong>{{ averageScore }}</strong>
                    </span>
                </div>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="'thumbs-up'">
            <div class="hand hand--{{ device }}" ins-animate-in-view>
                <div class="hand__thumbs-up hand__thumbs-up--{{ size }} hand__thumbs-up--animation hand__thumbs-up--animation-{{ size }}"></div>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="'ok'">
            <div class="hand hand--{{ device }}" ins-animate-in-view>
                <div class="hand__ok hand__ok--animation"></div>
            </div>
        </ng-container>
    </div>
</ng-container>